import React from 'react';
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';

interface WeighingCodeDisplayProps {
  weighingCode: string;
  weighingId?: string;
  tenantId?: string;
  siteId?: string;
  className?: string;
}

const WeighingCodeDisplay: React.FC<WeighingCodeDisplayProps> = ({
  weighingCode,
  weighingId,
  tenantId,
  siteId,
  className = ''
}) => {
  const [copied, setCopied] = React.useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(weighingCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Erreur lors de la copie:', error);
    }
  };

  return (
    <div className={`bg-green-50 border border-green-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-medium text-green-800">Code de pesée généré</h4>
        <button
          onClick={copyToClipboard}
          className="flex items-center text-green-600 hover:text-green-700 transition-colors"
        >
          {copied ? (
            <CheckIcon className="w-4 h-4 mr-1" />
          ) : (
            <ClipboardDocumentIcon className="w-4 h-4 mr-1" />
          )}
          <span className="text-xs">
            {copied ? 'Copié !' : 'Copier'}
          </span>
        </button>
      </div>

      <div className="space-y-2">
        {/* Code principal */}
        <div className="bg-white border border-green-300 rounded px-3 py-2">
          <span className="text-xs text-green-600 font-medium">Code:</span>
          <span className="ml-2 text-lg font-mono font-bold text-green-800">
            {weighingCode}
          </span>
        </div>

        {/* Informations système (cachées mais présentes) */}
        <div className="text-xs text-green-600 space-y-1">
          {weighingId && (
            <div className="flex justify-between">
              <span>ID système:</span>
              <span className="font-mono">{weighingId}</span>
            </div>
          )}
          {tenantId && (
            <div className="flex justify-between">
              <span>Tenant ID:</span>
              <span className="font-mono">{tenantId}</span>
            </div>
          )}
          {siteId && (
            <div className="flex justify-between">
              <span>Site ID:</span>
              <span className="font-mono">{siteId}</span>
            </div>
          )}
        </div>

        {/* Message de confirmation */}
        <div className="text-xs text-green-600 mt-3 p-2 bg-green-100 rounded">
          ✓ La pesée a été créée avec succès. Vous pouvez maintenant passer à l'étape suivante.
        </div>
      </div>
    </div>
  );
};

export default WeighingCodeDisplay;
